<script setup lang="ts">
import {Icon} from '@iconify/vue';

const props = defineProps({
  title: {type: String, required: true},
  ariaId: {type: String, required: true},
  open: {type: Boolean, default: false},
});

const emit = defineEmits<{
  (e: 'toggle'): void;
}>();

const content = ref<HTMLElement>();

const contentClass = computed(() => {
  console.log('props.open', props.open, content.value);
  if (props.open && content.value) return {maxHeight: `${content.value.scrollHeight + 20}px`, opacity: '1'};
  else return {maxHeight: '0px', opacity: '0'};
});
</script>

<template>
  <div class="accordian-item w-full bg-[#00000017] rounded-[.6rem]">
    <h3 class="font-bold text-[1.75rem] leading-14">
      <button :id="ariaId" class="w-full text-left cursor-pointer font-bold flex justify-between items-center" :aria-expanded="open" :aria-controls="ariaId + '-content'" @click.prevent="emit('toggle')">
        <div class="max-w-[80%] text-[3rem]">{{ title }}</div>

        <span class="mr-3">
          <Icon v-if="!open" icon="material-symbols:arrow-drop-down-rounded" class="!w-[3rem] !h-[3rem]" />
          <Icon v-else icon="material-symbols:arrow-drop-up-rounded" class="!w-[3rem] !h-[3rem]" />
        </span>
      </button>
    </h3>

    <section :id="ariaId + '-content'" class="overflow-hidden transition-[max-height,opacity] duration-300" :style="contentClass" :aria-labelledby="ariaId">
      <div class="pt-8">
        <div ref="content" class="content text-[1.7rem]">
          <slot class="!text-[1.7rem]"></slot>
        </div>
      </div>
    </section>
  </div>
</template>

<style lang="scss">
@use '@/assets/scss/queries';
.accordian-item {
  padding: 2rem 6rem;

  @include queries.for-size(phone) {
    padding: 1.5rem 2rem;
  }
  section {
    .content {
      p {
        font-size: 1.7rem;
        line-height: 1.95rem;

        @include queries.for-size(phone) {
          font-size: 2rem !important;
        }
      }
    }
  }
}
</style>
